import { ComponentsProps, ComponentsOverrides, ComponentsVariants } from '@mui/material';
import { Theme } from '@mui/system/createTheme';
import { baseTheme } from '../base-theme';

export const MuiCssBaseline: {
    defaultProps?: ComponentsProps['MuiCssBaseline'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiCssBaseline'];
    variants?: ComponentsVariants['MuiCssBaseline'];
} = {
    styleOverrides: {
        body: {
            backgroundColor: baseTheme.palette.background.paper,
        },
    },
};
